<template>
    <div @keyup="onKeyUp" class="singleSelect" :class="{ open: isOpen }">
        <button class="dropdown-toggle item-selected"
                :id="`${id}-button`"
                type="button"
                aria-haspopup="true"
                :aria-expanded="isAriaExpanded"
                :aria-controls="`${id}-dropdown`"
                @click="toggleMenu">
            <template v-if="showTagIcon">
                <svg width="24" height="24" aria-hidden="true"><use xlink:href="#icon_tag"></use></svg>
            </template>
            <span class="dropdown-text">{{ (selectedItem && parseInt(selectedItem.value) !== -1 ? selectedItem.name : defaultLabel) }}</span>
            <svg width="24" height="24" aria-hidden="true"><use xlink:href="#icon_dropdown"></use></svg>
        </button>
        <ul class="dropdown-menu"
            :id="`${id}-dropdown`"
            ref="dropdownMenu"
            role="menuitem"
            :aria-labelledby="`${id}-button`">
            <li v-for="item in items" :key="item.value" role="none">
                <a href="javascript:void(0);"
                   class="dropdown-item"
                   :class="{ active: selectedItem && selectedItem.value === item.value }"
                   @click="handleChange(item)"
                   role="menuitem">
                    {{ item.name || item.Name }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'SingleSelector',
        props: {
            rawList: {
                type: [Object],
                default: () => []
            },
            preselectedItem: {
                type: [String, Number],
                default: null
            },
            defaultLabel: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            showTagIcon: {
                type: Boolean,
                default: false
            }
        },
        inject: {
            parentBus: { default: null }
        },
        data() {
            let list = this.rawList;
            if (typeof this.rawList === 'string') {
                const t = this.rawList.trim();
                if (t.startsWith('[')) {
                    try { list = JSON.parse(t); } catch { list = []; }
                }
            } else if (!Array.isArray(this.rawList) && this.rawList && typeof this.rawList === 'object') {
                list = Object.values(this.rawList);
            }

            // normalize items to ensure unique and defined `value` and readable `name`
            list = (Array.isArray(list) ? list : []).map((it, idx) => {
                if (!it) return { name: this.defaultLabel, value: idx };
                const value = typeof it.value !== 'undefined' && it.value !== null
                    ? it.value
                    : (typeof it.id !== 'undefined' && it.id !== null ? it.id : idx);
                const name = it.name || it.Name || String(it.title || value || '');
                return { ...it, value, name };
            });

            const initialSelected = list.find(item => item && item.selected)
                || list.find(item => item && item.value === this.preselectedItem)
                || { name: this.defaultLabel, value: null };
            return {
                items: list,
                selectedItem: initialSelected,
                isOpen: false
            };
        },
        created() {
            let parent = this.$parent;
            let foundBus = null;
            while (parent) {
                if (parent.bus && typeof parent.bus.$on === 'function') {
                    foundBus = parent.bus;
                    break;
                }
                parent = parent.$parent;
            }
            this._bus = this.parentBus || foundBus || null;
            const bus = this._bus;
            if (bus && typeof bus.$on === 'function') {
                bus.$on('hideOtherDropdowns', (clickedItem) => {
                    if (clickedItem !== this && this.$el && !this.$el.contains(clickedItem)) {
                        this.isOpen = false;
                    }
                });
                bus.$on('clearAll', () => {
                    this.selectedItem = { name: this.defaultLabel, value: -1 };
                    this.isOpen = false;
                });
                bus.$on('clearAllDropdowns', () => {
                    this.selectedItem = { name: this.defaultLabel, value: -1 };
                    this.isOpen = false;
                });

                bus.$on('dropdownChange', (val, dropdownId) => {
                    if (val && val.reset) {
                        this.selectedItem = { name: this.defaultLabel, value: null };
                        this.isOpen = false;
                    }
                });
            }
        },
        computed: {
            isAriaExpanded() {
                return this.isOpen ? 'true' : 'false';
            }
        },
        watch: {
            preselectedItem(newVal, oldVal) {
                if (newVal !== oldVal) {
                    const arr = Array.isArray(this.items) ? this.items : [];
                    this.selectedItem = arr.find(item => item && item.value === newVal) || { name: this.defaultLabel, value: 0 };
                }
            },
            rawList(newVal) {
                let list = Object.values(newVal);
                list = (Array.isArray(list) ? list : []).map((it, idx) => {
                    if (!it) return { name: this.defaultLabel, value: idx };
                    const value = typeof it.value !== 'undefined' && it.value !== null
                        ? it.value
                        : (typeof it.id !== 'undefined' && it.id !== null ? it.id : idx);
                    const name = it.name || String(it.title || value || '');
                    return { ...it, value, name };
                });
                this.items = list;
                const prevValue = this.selectedItem && this.selectedItem.value != null ? this.selectedItem.value : null;
                const matched = prevValue != null ? list.find(item => item && String(item.value) === String(prevValue)) : null;
                if (matched) {
                    this.selectedItem = matched;
                } else {
                    const defaultSelection = list.find(item => item && item.selected);
                    this.selectedItem = defaultSelection
                        || list.find(item => item && String(item.value) === String(this.preselectedItem))
                        || { name: this.defaultLabel, value: null };
                }
            }
        },
        methods: {
            onKeyUp(e) {
                if (e.keyCode >= 65 && e.keyCode <= 90) { // a-z
                    const lowerKey = e.key.toLowerCase();
                    const arr = Array.isArray(this.items) ? this.items : [];
                    arr.some((item, index) => {
                        const itemName = item && item.name;
                        if (itemName && itemName.toLowerCase().startsWith(lowerKey)) {
                            if (this.$refs.dropdownMenu) {
                                $(this.$refs.dropdownMenu).find('a').eq(index).trigger('focus');
                            }
                            return true;
                        }
                    });
                } else if (e.keyCode === 27 && this.isOpen) { // ESC
                    this.isOpen = false;
                }
            },
            toggleMenu() {
                this.isOpen = !this.isOpen;
            },
            handleChange(item, oldVal) {
                const previous = this.selectedItem ? this.selectedItem.value : null;
                this.selectedItem = item;
                this.isOpen = false;

                this.$emit('change', { id: item.value, name: item.name }, this.id, oldVal);

                if (this._bus && typeof this._bus.$emit === 'function') {
                    this._bus.$emit(
                        'dropdownChange',
                        { id: item.value, name: item.name },
                        this.id,
                        { id: previous }
                    );
                }
            }
        }
    };
</script>